export const merchandisePricesFeatureKey = 'merchandisePrices';

export interface State {
  [productId: string]: [discount: number];
}
